import { Link } from 'react-router-dom';
import PolicyLayout from '../components/PolicyLayout';
import { ADDRESS, COMPANY_NAME, PRODUCT_NAME, SITE_DOMAIN, SITE_NAME, SITE_URL } from '../constants/site';

export default function PrivacyPolicy() {
  return (
    <PolicyLayout
      title="Privacy Policy"
      intro={`How ${COMPANY_NAME} collects, uses, and protects your information when you use ${SITE_DOMAIN}.`}
    >
      <h2>1. Who we are</h2>
      <p>
        {SITE_NAME} ({SITE_URL}) is an independent technical helps service operated by {COMPANY_NAME},{' '}
        {ADDRESS} (“we”, “us”, “our”). This policy explains what personal information we collect when you
        visit the website, use live chat, submit a form, or receive helps, and how we handle it.
      </p>

      <h2>2. Information we collect</h2>
      <h3>Information you give us</h3>
      <ul>
        <li>Your name, email address, and phone number when you submit a contact form.</li>
        <li>Messages, chat transcripts, and descriptions of the problem you need help with.</li>
        <li>Technical details you choose to share, such as your {PRODUCT_NAME} edition, operating system, and error messages.</li>
        <li>Billing details if you purchase a paid helps service (processed by our payment provider).</li>
      </ul>
      <h3>Information collected automatically</h3>
      <ul>
        <li>IP address, browser type, device type, and approximate location.</li>
        <li>Pages visited, the page that referred you, and time spent on the site.</li>
        <li>Cookies and similar technologies, described in our <Link to="/cookie-policy">Cookie Policy</Link>.</li>
      </ul>

      <h2>3. How we use your information</h2>
      <ul>
        <li>To respond to your enquiries and provide the technical helps you request.</li>
        <li>To contact you about your request by email, phone call, or chat.</li>
        <li>To process payments and issue refunds where applicable.</li>
        <li>To improve our website, guides, and helps quality.</li>
        <li>To prevent fraud, abuse, and security incidents.</li>
        <li>To comply with legal obligations.</li>
      </ul>
      <p>
        <strong>We do not sell your personal information.</strong>
      </p>

      <h2>4. Remote helps sessions</h2>
      <p>
        If you agree to a remote session, our technician can view your screen only while the session is
        active and only with your permission. You can end the session at any time. We do not copy your
        personal files except where you specifically ask us to as part of a fix, such as moving a backup.
      </p>

      <h2>5. Sharing your information</h2>
      <p>We share personal information only with:</p>
      <ul>
        <li>Service providers who help us run the website, live chat (Zoho SalesIQ), lead management, email, and payments, under contracts that require them to protect it.</li>
        <li>Authorities, when required by law or to protect our rights, users, or the public.</li>
        <li>A successor business in the event of a merger or sale, subject to this policy.</li>
      </ul>

      <h2>6. Data retention</h2>
      <p>
        We keep helps records for as long as needed to provide helps, resolve disputes, and meet legal
        and accounting requirements, then delete or anonymise them.
      </p>

      <h2>7. Security</h2>
      <p>
        We use reasonable technical and organisational measures, including encrypted connections (HTTPS),
        to protect your information. No method of transmission over the internet is completely secure, so
        we cannot guarantee absolute security.
      </p>

      <h2>8. Your rights</h2>
      <p>
        Depending on where you live, you may have the right to access, correct, delete, or restrict the use
        of your personal information, to object to processing, and to request a copy of your data.
        California residents may request disclosure of the categories of information we collect and may
        ask us to delete it. To make a request, contact us using the details below. We will not
        discriminate against you for exercising these rights.
      </p>

      <h2>9. Children’s privacy</h2>
      <p>
        Our services are not directed to children under 13, and we do not knowingly collect their personal
        information. If you believe a child has provided us with information, contact us and we will delete it.
      </p>

      <h2>10. Third-party links</h2>
      <p>
        Our website may link to other websites, including software publishers. We are not responsible for
        their privacy practices and encourage you to read their policies.
      </p>

      <h2>11. Changes to this policy</h2>
      <p>
        We may update this policy from time to time. The “Last updated” date above shows when it was last
        changed. Continued use of the website after changes means you accept the updated policy.
      </p>

      <h2>12. Contact us</h2>
      <p>
        For privacy questions or requests, use live chat or our <Link to="/contact-us">contact form</Link>, or
        write to {COMPANY_NAME}, {ADDRESS}.
      </p>
    </PolicyLayout>
  );
}
